import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeUnit, setActiveUnitState] = useState(
    () => localStorage.getItem("uee_unit") || ""
  );

  const setActiveUnit = (key) => {
    if (key) {
      localStorage.setItem("uee_unit", key);
      setActiveUnitState(key);
    } else {
      localStorage.removeItem("uee_unit");
      setActiveUnitState("");
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("uee_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("uee_token");
        localStorage.removeItem("uee_session");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("uee_token", data.token);
    if (data.session_id) {
      localStorage.setItem("uee_session", data.session_id);
    }
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      const sessionId = localStorage.getItem("uee_session");
      await api.post("/auth/logout", {}, {
        headers: sessionId ? { "X-Session-Id": sessionId } : {},
      });
    } catch (_) { /* ignore */ }
    localStorage.removeItem("uee_token");
    localStorage.removeItem("uee_session");
    localStorage.removeItem("uee_unit");
    setUser(null);
    setActiveUnitState("");
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, activeUnit, setActiveUnit }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
